import { useState } from "react";
import { startPayment } from "@/lib/razorpay";
import { toast } from "sonner";
import { CreditCard, ShieldCheck } from "lucide-react";

/**
 * PaymentButton
 * props: purpose, item, name, email, phone?, application_id?, label, onPaid?, className?
 */
export default function PaymentButton({ purpose, item, name, email, phone, application_id, label = "Pay now", onPaid, onBeforePay, onFailed, className = "btn-gold", testid = "pay-button" }) {
    const [loading, setLoading] = useState(false);
    const [paid, setPaid] = useState(false);

    const pay = async () => {
        if (!name || !email) {
            toast.error("Name and email are required to pay");
            return;
        }
        if (onBeforePay) {
            try { onBeforePay(); } catch (_e) { /* noop */ }
        }
        setLoading(true);
        const res = await startPayment(
            { purpose, item, name, email, phone, application_id },
            {
                onSuccess: () => {
                    setPaid(true);
                    toast.success("Payment successful — a receipt is on its way");
                    if (onPaid) onPaid();
                },
                onFailed,
            }
        );
        setLoading(false);
        if (!res.ok && !res.dismissed && res.error) toast.error(res.error);
    };

    if (paid) {
        return (
            <span className="flex items-center gap-2 label-mono text-[var(--emerald)]" data-testid={`${testid}-done`}>
                <ShieldCheck className="w-4 h-4" /> Payment complete
            </span>
        );
    }

    return (
        <button type="button" onClick={pay} disabled={loading} className={className} data-testid={testid}>
            {loading ? "Opening…" : (<>{label} <CreditCard className="w-4 h-4" /></>)}
        </button>
    );
}
